import styled, { createGlobalStyle } from "styled-components";


export const Wrapper = styled.div`
  background-color: #1e1e1e;
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #e0e0e0;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  max-width: 100%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`;

export const Icon = styled.div`
  font-size: 20px;
  color: #aaa;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Info = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const Title = styled.div`
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Meta = styled.div`
  font-size: 12px;
  color: #888;
  margin-top: 2px;
`;

export const Progress = styled.div`
  font-size: 12px;
  border: 1px solid #555;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
`;

export const CustomMediaExtensionStyles = createGlobalStyle`
  .remirror-editor .remirror-pdf-wrapper {
    position: relative;
    overflow: visible;
    max-width: 100%;
    margin: 0.5rem 0px;
    border-radius: 8px;
    border: 1px solid white;
    transition: border-color 0.2s ease;
  }

  .remirror-editor .remirror-pdf-wrapper:hover {
    outline: 2px solid #f0f0f0!important;
  }

  .remirror-editor .remirror-pdf-wrapper[data-selected="true"] {
    outline: 2px solid #6567eb!important;
  }
`